import { Injectable } from "@angular/core";
import { SampleApiUrlUtil } from "@sharedcommon/util/sample-service.util";
import { Observable } from "rxjs";
import { NeqHttpClient } from "@sharedcommon/rest/http-client.config";
import { SharedPagedResponse } from "@sharedcommon/model/shared-paged-response.model";
import { AnalysisOriginDto } from "@sharedcommon/model/sample/analysis-origin.model";
import { AnalysisOriginFilterDto } from "@sharedcommon/model/sample/filter/analysis-origin-filter.model";

@Injectable({ providedIn: 'root'})
export class AnalysisOriginRestService {
  constructor(private neqHttpClient: NeqHttpClient){}

  /**
   * Search analysis origin
   * Response code 200 - Paged result
   * Response code 500 - Error
   * HTTP GET analysis-origin/search
   * Java method: com.neovia.services.sample.controller.AnalysisOriginController.search
   */
  search(filterDto: AnalysisOriginFilterDto): Observable<SharedPagedResponse<AnalysisOriginDto>> {
    return this.neqHttpClient.request({ method: 'GET', url: SampleApiUrlUtil.formatApiUrl(`analysis-origin/search`), data: filterDto });
  }

  /**
   * Search analysis origin
   * Response code 200 - Paged result
   * Response code 500 - Error
   * HTTP GET analysis-origin/search
   * Java method: com.neovia.services.sample.controller.AnalysisOriginController.search
   */
  getAll(): Observable<AnalysisOriginDto[]> {
    return this.neqHttpClient.request({ method: 'GET', url: SampleApiUrlUtil.formatApiUrl(`analysis-origin`) });
  }
}